export function clearObservationSpider() {
  this.activeObservationSpiderKey = null;
}

export function getClusterLeaves(sourceName, clusterId, limit = 1000) {
  return new Promise(resolve => {
    if (!this.map || !this.map.getSource(sourceName)) {
      resolve([]);
      return;
    }
    this.map
      .getSource(sourceName)
      .getClusterLeaves(clusterId, limit, 0, (err, leaves) => {
        if (err || !Array.isArray(leaves)) {
          resolve([]);
          return;
        }
        resolve(leaves);
      });
  });
}

export async function tryOpenSpiderForSameCoordinateCluster(
  sourceName,
  clusterFeature
) {
  if (!clusterFeature || !clusterFeature.properties || !clusterFeature.geometry)
    return false;
  if (sourceName !== 'Observations') return false;
  const clusterId = clusterFeature.properties.cluster_id;
  if (clusterId === undefined || clusterId === null) return false;
  const pointCount = Number(clusterFeature.properties.point_count) || 0;
  if (pointCount <= 1) return false;

  const leaves = await this.getClusterLeaves(
    sourceName,
    clusterId,
    Math.min(Math.max(pointCount, 2), 2000)
  );
  if (!Array.isArray(leaves) || leaves.length <= 1) return false;

  const coordKeys = new Set();
  leaves.forEach(feature => {
    const coords =
      feature && feature.geometry && Array.isArray(feature.geometry.coordinates)
        ? feature.geometry.coordinates
        : null;
    if (!coords || coords.length < 2) return;
    const lng = Number(coords[0]);
    const lat = Number(coords[1]);
    if (!Number.isFinite(lng) || !Number.isFinite(lat)) return;
    coordKeys.add(`${lng.toFixed(5)}:${lat.toFixed(5)}`);
  });
  if (coordKeys.size > 1) return false;

  const overlapKey = `mapbox:${String(clusterId)}`;
  this.overlapObservationGroups = {
    ...this.overlapObservationGroups,
    [overlapKey]: leaves
  };
  this.observationClusterMembers = {
    ...this.observationClusterMembers,
    [overlapKey]: leaves
  };

  if (this.activeObservationSpiderKey === overlapKey) {
    this.clearObservationSpider();
    if (this.props.clearCamtrapFocus) this.props.clearCamtrapFocus();
    return true;
  }

  this.activeObservationSpiderKey = overlapKey;
  if (this.setClusterSelectionFilter)
    this.setClusterSelectionFilter(overlapKey);
  const memberIds = leaves
    .map(f => String((f.properties && f.properties.EntityId) || ''))
    .filter(Boolean);
  if (memberIds.length > 0 && this.props.fetchClusterResults) {
    this.props.fetchClusterResults(memberIds);
  }

  return true;
}
